<script>
import Pagination from "./PromotionPagination";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import trainingProgramAPI from "../../../../services/standards/trainingProgram/trainingProgramAPI";

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      themes: [],
      search: "",
      yearFilter: null,
      deleteCount: 0,
      itemData: null,
    };
  },
  computed: {
    yearOptions() {
      const y = new Date().getFullYear();
      const years = [{ value: null, text: "Todos los años" }];
      for (let i = y + 1; i >= 2020; i--) years.push({ value: i, text: String(i) });
      return years;
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    // Aplica el filtro de año (resetea a la primera página y reconsulta).
    applyYearFilter() {
      if (this.$refs.paginator) {
        this.$refs.paginator.page = 1;
        this.$refs.paginator.query();
      }
    },

    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
          if (Array.isArray(this.itemData)) {
            this.deleteCount = this.itemData.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    searchData() {
      console.log(this.search);
    },
    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    goVer(ID) {
      this.$router.push({
        path: `/forms/estandares/${this.companyID}/promocion-prevencion-ver/${ID}`,
      });
    },

    goAsistencia(ID) {
      this.$router.push({
        path: `/forms/estandares/${this.companyID}/asistencia-capacitacion/${ID}`,
      });
    },

    deletePromocion(id) {
      trainingProgramAPI.deletePromocion(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';

          const itemChange = {
            companies_id: this.companyID,
            item_id: 9,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha eliminado con éxito!",
                  icon: "success",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    // Clase del badge (flag visual): verde = Ejecutado, ámbar = Pendiente.
    statusBadgeClass(status) {
      return status === "Ejecutado" ? "badge-success" : "badge-warning text-dark";
    },

    // Aplica un estado y persiste. Alimenta el cronograma y el % del Plan Anual.
    setStatus(item, status) {
      if (!status || item.status === status) return;
      const prev = item.status;
      item.status = status;
      trainingProgramAPI.updateStatus(item.id, status)
        .then(() => {
          if (this.$bvToast && this.$bvToast.toast) {
            this.$bvToast.toast(`Estado: ${status}`, { variant: "success", noCloseButton: true, autoHideDelay: 1500 });
          }
        })
        .catch((error) => {
          console.log(error);
          item.status = prev; // revertir si falla
          Swal.fire("Error", "No se pudo actualizar el estado", "error");
        });
    },

    getThemeID(theme) {
      if (theme === "BIOLÓGICO") {
        return 1;
      } else if (theme === "FÍSICO") {
        return 2;
      } else if (theme === "QUÍMICO") {
        return 3;
      } else if (theme === "PSICOSOCIAL") {
        return 4;
      } else if (theme === "BIOMECÁNICO") {
        return 5;
      } else if (theme === "CONDICIONES") {
        return 6;
      } else if (theme === "FENÓMENOS") {
        return 7;
      } else {
        return 8;
      }
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>


<template>

  <div class="row" v-if="getRole('Consultar') || !allowAccess()">
    <div class="card-body">

      <div class="row pb-3">
        <div class="col-6">
          <form @submit.prevent="fetch()" class="form-inline">
            <div class="form-group mr-2">

              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                class="form-control px-2" placeholder="Buscar"></b-form-input>

              <div class="col-1">
                <button type="submit" class="btn btn-primary px-2">Buscar</button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-6">
          <div class="form-inline justify-content-end">
            <label for="yearFilter" class="mr-2 mb-0 text-muted small">Filtrar por año</label>
            <b-form-select id="yearFilter" v-model="yearFilter" @change="applyYearFilter" size="sm"
              class="form-control" style="max-width: 180px;">
              <b-form-select-option v-for="opt in yearOptions" :key="opt.text" :value="opt.value">
                {{ opt.text }}
              </b-form-select-option>
            </b-form-select>
          </div>
        </div>
      </div>
      <table
        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
        <thead class="table-active">
          <tr>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Tema
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Fecha planificada de inicio
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3">
              Fecha planificada fin
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
              Observaciones
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
              Estado
            </th>
            <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="item in themes" :key="item.id">
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ item.training_done }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ dateConvert(item.start_date) }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ dateConvert(item.end_date) }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2">
              {{ item.observations }}
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle">
              <!-- Flag visual estático (color) + edición al clic -->
              <b-dropdown size="sm" variant="link" toggle-class="p-0 text-decoration-none" no-caret
                :disabled="!allowAccess() || !getRole('Editar')">
                <template v-slot:button-content>
                  <span class="badge badge-pill px-2 py-1" :class="statusBadgeClass(item.status)">
                    {{ item.status || 'Pendiente' }}
                  </span>
                </template>
                <b-dropdown-item @click="setStatus(item, 'Pendiente')">Pendiente</b-dropdown-item>
                <b-dropdown-item @click="setStatus(item, 'Ejecutado')">Ejecutado</b-dropdown-item>
              </b-dropdown>
            </td>
            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
              <div class="col-sm-12">
                <b-dropdown variant="primary" :disabled="!allowAccess()">
                  <template v-slot:button-content>
                    <i class="mdi mdi-eye"></i>
                  </template>
                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" v-on:click="goVer(item.id)">
                    Ver
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')" v-on:click="goAsistencia(item.id)">
                    Asistencia
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                    v-on:click="deletePromocion(item.id)">Eliminar</b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination :companyID="companyID" ref="paginator" :search="search" :year="yearFilter"
        @fetch="(items) => (themes = items)" />
    </div>
  </div>
</template>
